import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

function StatusPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('checking');
  const [dossier, setDossier] = useState(null);
  const [pollingCount, setPollingCount] = useState(0);

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/payments/checkout/status/${sessionId}`
      );
      
      if (response.data.payment_status === 'paid') {
        setStatus('paid');
        // Get dossier info
        const dossierId = response.data.metadata?.dossier_id;
        if (dossierId) {
          const dossierResponse = await axios.get(
            `${API_URL}/api/dossiers/${dossierId}`
          );
          setDossier(dossierResponse.data);
        }
      } else if (pollingCount < 5) {
        // Poll again
        setTimeout(() => {
          setPollingCount(pollingCount + 1);
          checkPaymentStatus();
        }, 2000);
      } else {
        setStatus('pending');
      }
    } catch (error) {
      console.error('Error checking status:', error);
      setStatus('error');
    }
  };

  if (status === 'checking') {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl mb-4 animate-pulse">⏳</div>
          <h2 className="text-2xl font-bold mb-4">Vérification du paiement...</h2>
          <p className="text-muted-foreground">Veuillez patienter</p>
        </div>
      </div>
    );
  }

  if (status === 'paid') {
    return (
      <div className="min-h-screen bg-background py-12">
        <div className="container-narrow">
          <div className="bg-card rounded-xl shadow-lg p-8 border border-border text-center">
            <div className="text-6xl mb-4">✅</div>
            <h2 className="text-3xl font-bold mb-4" data-testid="payment-success">
              Paiement réussi !
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Merci pour votre confiance. Votre dossier est en cours de traitement.
            </p>
            
            <div className="bg-secondary/50 p-6 rounded-lg mb-8">
              <h3 className="font-semibold mb-2">Numéro de dossier</h3>
              <p className="text-2xl font-mono text-primary">
                {dossier?.id || 'Chargement...'}
              </p>
            </div>

            <div className="space-y-4 text-left">
              <div className="flex items-start gap-3">
                <div className="text-2xl">📧</div>
                <div>
                  <h4 className="font-semibold">Email de confirmation envoyé</h4>
                  <p className="text-sm text-muted-foreground">
                    Vous allez recevoir un email de confirmation à {dossier?.user_contact?.email}
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="text-2xl">🤖</div>
                <div>
                  <h4 className="font-semibold">Analyse en cours</h4>
                  <p className="text-sm text-muted-foreground">
                    Notre système analyse actuellement vos documents et votre situation
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="text-2xl">👨‍💼</div>
                <div>
                  <h4 className="font-semibold">Validation humaine</h4>
                  <p className="text-sm text-muted-foreground">
                    Un expert validera votre courrier avant envoi
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="text-2xl">📨</div>
                <div>
                  <h4 className="font-semibold">Réception du courrier</h4>
                  <p className="text-sm text-muted-foreground">
                    Vous recevrez votre courrier finalisé par email sous 24-48h
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-4 bg-accent/10 border border-accent/20 rounded-lg">
              <p className="text-sm font-medium">
                ⚠️ Rappel : Ce service est une assistance rédactionnelle uniquement. Ce n'est pas un conseil juridique.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="text-6xl mb-4">⚠️</div>
        <h2 className="text-2xl font-bold mb-4">Statut du paiement en attente</h2>
        <p className="text-muted-foreground mb-4">
          Le paiement est en cours de traitement. Veuillez rafraîchir la page dans quelques instants.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-6 py-2 bg-accent text-white rounded-lg hover:bg-accent/90"
        >
          Rafraîchir
        </button>
      </div>
    </div>
  );
}

export default StatusPage;
